import { useEffect } from 'react';

import { useChildComponentRouteV2, useSearchParams } from '@gogame/screens';

import FinancialResultDetails from './FinancialResultDetails';
import { TAB_DETAILS, TAB_INVOICES, TAB_ACTIONS_LOG } from '../../constants';

export const FinancialResultDetailsRouteElement = ({ onChange }) => {
  const activeTabId = useActiveTab();

  return useChildComponentRouteV2(FinancialResultDetails, {
    onChange,
    activeTabId,
  });
};

const mapLabelToTabIds = {
  invoices: TAB_INVOICES,
  details: TAB_DETAILS,
  actionsLog: TAB_ACTIONS_LOG,
};

function useActiveTab() {
  const [searchParams, setSearchParams] = useSearchParams();
  let activeTabId;
  const tabParam = searchParams.get('tab');
  if (tabParam) {
    activeTabId = mapLabelToTabIds[tabParam];
  }

  useEffect(() => {
    if (activeTabId?.length) {
      const newSearchParams = new URLSearchParams(searchParams);
      newSearchParams.delete('tab');
      setSearchParams(newSearchParams, { replace: true });
    }
  }, [activeTabId, searchParams]);

  return activeTabId;
}
